<template>
  <div>
    <v-row>
      <v-col md="6" class="pa-12">
        Toolboxmeetings
        <v-row align="center">
          <v-col md="10">
            <StaafGrafiek
              :chartdata="chartdataToolboxmeetings"
              :options="options"
              class="Grafiek"
              ref="toolboxmeetings"
            ></StaafGrafiek>
          </v-col>
          <v-col md="2">
            <span>
              <v-icon color="red" x-large v-show="toolboxmeetingInc < 0">mdi-arrow-down-bold</v-icon>
              <v-icon color="green" x-large v-show="toolboxmeetingInc > 0">mdi-arrow-up-bold</v-icon>
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" class="pa-12">
        Meldingen veilig
        <v-row align="center">
          <v-col md="10">
            <StaafGrafiek
              :chartdata="chartdataMeldingVeilig"
              :options="options"
              class="Grafiek"
              ref="meldingveilig"
            ></StaafGrafiek>
          </v-col>
          <v-col md="2">
            <span>
              <v-icon color="red" x-large v-show="meldingveiligInc < 0">mdi-arrow-down-bold</v-icon>
              <v-icon color="green" x-large v-show="meldingveiligInc > 0">mdi-arrow-up-bold</v-icon>
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" class="pa-12">
        Werkplekinspecties
        <v-row align="center">
          <v-col md="10">
            <StaafGrafiek
              :chartdata="chartdataWerkplekinspecties"
              :options="options"
              class="Grafiek"
              ref="werkplekinspecties"
            ></StaafGrafiek>
          </v-col>
          <v-col md="2">
            <span>
              <v-icon color="red" x-large v-show="werkplekinspectiesInc < 0">mdi-arrow-down-bold</v-icon>
              <v-icon color="green" x-large v-show="werkplekinspectiesInc > 0">mdi-arrow-up-bold</v-icon>
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" class="pa-12">
        Meldingen onveilig
        <v-row align="center">
          <v-col md="10">
            <StaafGrafiek
              :chartdata="chartdataMeldingOnveilig"
              :options="options"
              class="Grafiek"
              ref="meldingonveilig"
            ></StaafGrafiek>
          </v-col>
          <v-col md="2">
            <span>
              <v-icon color="red" x-large v-show="meldingonveiligInc > 0">mdi-arrow-up-bold</v-icon>
              <v-icon color="green" x-large v-show="meldingonveiligInc < 0">mdi-arrow-down-bold</v-icon>
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StaafGrafiek from "@/charts/staafgrafiek.vue";

var backgroundColors = [
  "rgba(128, 128, 128, 0.2)",
  "rgba(128, 128, 128, 0.2)",
  "rgba(128, 128, 128, 0.2)",
  "rgba(64, 64, 64, 0.2)"
];
var borderColors = [
  "rgba(128, 128, 128, 1)",
  "rgba(128, 128, 128, 1)",
  "rgba(128, 128, 128, 1)",
  "rgba(64, 64, 64, 1)"
];

export default {
  name: "ProjectActies",
  components: { StaafGrafiek },
  props: {
    periode: {
      type: Number,
      default: null
    },
    project: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    loaded: false,
    toolboxmeetingInc: 0,
    meldingveiligInc: 0,
    werkplekinspectiesInc: 0,
    meldingonveiligInc: 0,
    chartdataToolboxmeetings: {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1
        }
      ]
    },
    chartdataMeldingVeilig: {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1
        }
      ]
    },
    chartdataMeldingOnveilig: {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1
        }
      ]
    },
    chartdataWerkplekinspecties: {
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1
        }
      ]
    },
    options: {
      legend: {
        display: false
      },
      tooltips: {
        enabled: true
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            display: false,
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: false
            }
          }
        ]
      }
    }
  }),
  methods: {
    loadData: function() {
      if (this.periode > 0 && this.project != null) {
        let data = {
          ProjectId: this.project.Id,
          PeriodeId: this.periode
        };
        this.$api.pProjectDashboardActies(data).then(response => {
          let labels = [];
          let Werkplekinspecties = [];
          let Toolboxmeetings = [];
          let MeldingVeilig = [];
          let MeldingOnveilig = [];
          for (var i = 0; i < response.data.length; i++) {
            labels.push(response.data[i].Periode);
            Werkplekinspecties.push(response.data[i].Werkplekinspecties);
            Toolboxmeetings.push(response.data[i].Toolboxmeetings);
            MeldingVeilig.push(response.data[i].MeldingVeilig);
            MeldingOnveilig.push(response.data[i].MeldingOnveilig);
          }

          this.chartdataToolboxmeetings.labels = labels;
          this.chartdataMeldingVeilig.labels = labels;
          this.chartdataMeldingOnveilig.labels = labels;
          this.chartdataWerkplekinspecties.labels = labels;
          this.chartdataToolboxmeetings.datasets[0].data = Toolboxmeetings;
          this.chartdataMeldingVeilig.datasets[0].data = MeldingVeilig;
          this.chartdataMeldingOnveilig.datasets[0].data = MeldingOnveilig;
          this.chartdataWerkplekinspecties.datasets[0].data = Werkplekinspecties;

          // icons naast grafiek
          this.toolboxmeetingInc =
            response.data[3].Toolboxmeetings - response.data[2].Toolboxmeetings;
          this.werkplekinspectiesInc =
            response.data[3].Werkplekinspecties -
            response.data[2].Werkplekinspecties;
          this.meldingveiligInc =
            response.data[3].MeldingVeilig - response.data[2].MeldingVeilig;
          this.meldingonveiligInc =
            response.data[3].MeldingOnveilig - response.data[2].MeldingOnveilig;

          this.refresh();

          this.loaded = true;
        });
      } else {
        // Geen periode bekend
        this.toolboxmeetingInc = 0;
        this.werkplekinspectiesInc = 0;
        this.meldingveiligInc = 0;
        this.meldingonveiligInc = 0;
        this.chartdataToolboxmeetings.labels = [];
        this.chartdataMeldingVeilig.labels = [];
        this.chartdataMeldingOnveilig.labels = [];
        this.chartdataWerkplekinspecties.labels = [];
        this.chartdataToolboxmeetings.datasets[0].data = [];
        this.chartdataMeldingVeilig.datasets[0].data = [];
        this.chartdataMeldingOnveilig.datasets[0].data = [];
        this.chartdataWerkplekinspecties.datasets[0].data = [];
      }
    },
    refresh: function() {
      this.$refs.meldingonveilig.update();
      this.$refs.meldingveilig.update();
      this.$refs.toolboxmeetings.update();
      this.$refs.werkplekinspecties.update();
    }
  },
  watch: {
    periode() {
      this.loadData();
    },
    project() {
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
</style>